/**
 * What to show in admin "Receipt no." column and on printed invoices.
 *
 * - New manual receipts: plain digits in `receipt_number` (167437, …).
 * - Legacy / online: gateway or label in `receipt_number`, sequential id in `receipt_id`
 *   (167436, …) — show `receipt_id` only; payment id stays in the Payment column.
 */

export function displayReceiptNumber(row) {
  const num = String(row?.receiptNumber ?? '').trim();
  const id = row?.receiptId;
  const idStr = id != null && String(id).trim() !== '' ? String(id).trim() : '';

  if (num && /^\d{1,18}$/.test(num)) {
    return num;
  }

  if (idStr) {
    return idStr;
  }

  if (num) return num;
  return row?.id?.slice(0, 8) || '—';
}
